var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconupdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80014 8.65853C10.1591 8.65853 10.3485 9.08373 10.1084 9.35058L7.3075 12.4626C7.14278 12.6457 6.85579 12.6457 6.69107 12.4626L3.89022 9.35058C3.65006 9.08374 3.83943 8.65853 4.19843 8.65853H9.80014Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19843 5.34128C3.83943 5.34128 3.65006 4.91607 3.89022 4.64923L6.69107 1.53717C6.85579 1.35415 7.14278 1.35415 7.3075 1.53717L10.1084 4.64923C10.3485 4.91607 10.1591 5.34128 9.80014 5.34128L4.19843 5.34128Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconupdown);
export default __webpack_public_path__ + "static/media/iconupdown.9b05736c5a1f3a7cc9dc113e08289f77.svg";
export { ForwardRef as ReactComponent };